import { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { groupBuyAPi } from "src/api/groupBuyApi"
import useIsMobile from "src/customHook/useIsMobile"
import GroupBuy from "src/pages/Home/components/GroupBuy"
import { Helmet } from "react-helmet"
import { MetaTags, StructuredData, useSEO } from "src/components/SEO"

type Props = {}

function VoucherDetail({}: Props) {
  const navigate = useNavigate()

  const { isMobile } = useIsMobile(474)

  const [voucherDetail, setVoucherDetail] = useState<any>({})
  const params = useParams()

  const getVoucherDetail = async () => {
    try {
      const res: any = await groupBuyAPi.getVoucherDetail(params.id as string)
      if (res.result && !!res.data) {
        setVoucherDetail(res.data)
      } else {
        throw res
      }
    } catch (error) {}
  }

  useEffect(() => {
    getVoucherDetail()
  }, [params.id])

  // SEO configuration
  const seoData = {
    title: voucherDetail?.name || '바우처',
    description: voucherDetail?.description || `${voucherDetail?.name || '바우처'} - 특별한 혜택을 만나보세요`,
    image: voucherDetail?.image || voucherDetail?.brandLogo,
    type: 'product' as const
  }
  
  const { canonicalUrl, keywords, breadcrumb } = useSEO(seoData)

  return (
    <>
      {/* SEO Meta Tags */}
      {voucherDetail?.name && (
        <>
          <MetaTags
            title={seoData.title}
            description={seoData.description}
            image={seoData.image}
            url={canonicalUrl}
            type={seoData.type}
            keywords={keywords}
          />
          
          {/* Structured Data for Product */}
          <StructuredData
            type="Product"
            data={{
              name: voucherDetail.name,
              description: voucherDetail.description,
              image: voucherDetail.image,
              brandName: voucherDetail.brandName,
              price: voucherDetail.price || voucherDetail.salePrice,
              availability: voucherDetail.progress === 'AVAILABLE' 
                ? 'https://schema.org/InStock' 
                : 'https://schema.org/OutOfStock'
            }}
          />
          
          {/* Breadcrumb Structured Data */}
          <StructuredData
            type="BreadcrumbList"
            data={{
              items: breadcrumb
            }}
          />
        </>
      )}

      <Helmet>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, maximum-scale=10, minimum-scale=1"
        />
      </Helmet>

      <div className={isMobile ? "mx-[-24px]" : ""}>
        {voucherDetail?.brandId && (
          <GroupBuy
            brandId={voucherDetail?.brandId}
            mainColor="#15A0A1"
            colorButton="#2D2D2D"
            titleEx
            data={voucherDetail}
            onComplete={() => {
              // getVoucherDetail()
              setVoucherDetail(undefined)
              voucherDetail?.progress === "INCOMING" &&
                navigate("/group-buying/up-coming")
            }}
          />
        )}
      </div>
    </>
  )
}

export default VoucherDetail
